import { render, staticRenderFns } from "./FormCaixa.vue?vue&type=template&id=750ca232&"
import script from "./FormCaixa.vue?vue&type=script&lang=js&"
export * from "./FormCaixa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports